import type {VehicleSAutoPlatformAdvertisingAttribute} from './VehicleSAutoPlatformAdvertisingAttribute';

export type VehicleSAutoPlatformAdvertisingSettings = {
  platformCode: VehicleSAutoPlatformAdvertisingSettings.platformCode;
  enabled: boolean;
  attributes: Array<VehicleSAutoPlatformAdvertisingAttribute>;
  hasOverrides: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
};

export namespace VehicleSAutoPlatformAdvertisingSettings {
  export enum platformCode {
    SAUTO = 'sauto',
  }
}
